import _ from "lodash";
import { sha256 } from "hash.js";
import { makeAutoObservable, observable } from "mobx";
import { addDays } from "date-fns";

import { name } from "../../package.json";
import config from "../config";

export default class UserStorage {
  prefs = {};
  constructor({ authStore, useLocalStorage }) {
    makeAutoObservable(this, { prefs: observable.deep });
    this.storage = useLocalStorage ? localStorage : sessionStorage;
    this.authStore = authStore;
    this.load();
  }
  get prefix() {
    return `${name}:user`;
  }

  async load() {
    this.loaded = false;
    const hashedKey = await this.hashedKey;
    this.loaded = true;
    updateExpiry(`${this.prefix}:${hashedKey}`);
    try {
      this.prefs = JSON.parse(this.storage.getItem(hashedKey)) || {};
    } catch {
      this.prefs = {};
    }
  }

  async save() {
    const hashedKey = await this.hashedKey;
    updateExpiry(`${this.prefix}:${hashedKey}`);
    return this.storage?.setItem(hashedKey, JSON.stringify(this.prefs));
  }

  get hashedKey() {
    if (!this.authStore.username) throw "no username";
    return hash(`${this.authStore.username}:site-${config.siteid}:prefs`);
  }

  async setPref(key, value) {
    if (!this.prefs || !key) return;
    _.set(this.prefs, key, value);
    this.save();
  }
}

async function hash(message) {
  return sha256().update(message).digest("hex");
}

const expiryKey = `${name}:expiry`;
function updateExpiry(_key) {
  const expiry = loadExpiry();
  const now = new Date();
  if (_key)
    expiry[_key] = addDays(now, config.localPrefs.expireDays).toISOString();
  const currentEntries = [];
  Object.entries(expiry).forEach(([key, timestamp]) => {
    if (new Date() < new Date(timestamp)) {
      currentEntries.push([key, timestamp]);
    } else {
      localStorage.removeItem(key);
    }
  });
  if (currentEntries.length)
    localStorage.setItem(
      expiryKey,
      JSON.stringify(Object.fromEntries(currentEntries)),
    );
  else localStorage.removeItem(expiryKey);
}

function loadExpiry() {
  try {
    return JSON.parse(localStorage.getItem(expiryKey)) || {};
  } catch {
    return {};
  }
}

updateExpiry();
